// This is where information is stored for uploading metadata to the Head

export const backgammonHeadData = {
  title: 'Lord Of The Board Store',
  meta: {
    name: 'description',
    content: 'Lord Of The Board external store',
  },
};

export const spadesHeadData = {
  title: 'Spades Store',
  meta: {
    name: 'description',
    content: 'Spades external store',
  },
};
